import React from 'react'
import { connect } from 'react-redux';

import './UnprocessedRecords.css'
import $ from 'jquery'

import {
    fetchUnprocessedRecordsError,
    fetchUnprocessedRecordsList,
    fetchUnprocessedRecordsUnpublishedTemplateList,
    fetchUnprocessedRecordsPublishedTemplateList,
    process_filter,
    show_all_records,
    sort_records,
    clear_export,
    export_excel_unprocessedrecords,
    import_excel_unprocessedrecords,
    sortUnprocessedRecords
} from './actions'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'
import BootstrapErrorModal from '../../../SharedComponents/UserMessaging/BootstrapErrorModal';

import ProgressBar from './ProgressBar'
import LoadingSpinner from './LoadingSpinner'
import ImportSpinner from './ImportSpinner'

import "../styles/_loading.scss";

var Spinner = require('react-spinkit');

let chkReturn = 0;

class UnprocessedRecords extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unprocessed_record: {
                BRPRID: '',
                BRMFG: '',
                BRLIN: '',
                BRPART: '',
                BRDES1: '',
                BRDES2: '',
                BRDES3: '',
                TEMPLATEID: '',
                SUPPLEMENTAL_MISSING: ''
            },
            progress: this.props.unprocessedRecordsList.percent_complete,
            percentage: 0,
            value: -1,
            complete: false,
            listFilterValue: '0',
            publishedTemplateFilterValue: '0', 
            templateUnpublishedFilterValue: '0', 
            manufacturerFilterValue: '0',
            productLineFilterValue: '0',
            unprocessed_records_list: this.props.unprocessedRecordsList.unprocessedRecordsList,
            page: 1,
            sortBy: "",
            sortOrder: "Unspecified"
        };

        this.fetchUnprocessedRecordsErrorClear = this.fetchUnprocessedRecordsErrorClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);
        this.sortUnprocessedRecordsOperation = this.sortUnprocessedRecordsOperation.bind(this);
        this.sortUnprocessedRecordsCall = this.sortUnprocessedRecordsCall.bind(this);

        this.close_modal = this.close_modal.bind(this);
        this.close_modal_success = this.close_modal_success.bind(this);
        this.jobInfoClearImport = this.jobInfoClearImport.bind(this);
        this.jobInfoClearExport = this.jobInfoClearExport.bind(this);
        this.showJobId = this.showJobId.bind(this);

        this.clearForm = this.clearForm.bind(this);
        this.import_and_end = this.import_and_end.bind(this);
    }

    componentDidMount() {
        setInterval(function () {
            if ($('a#JobID').length) {
                $('a#JobID').css('color', '#a02923')
                $('a#JobID').css('cursor', 'pointer')
                $('a#JobID').css('text-decoration', 'underline')
            }
        }, 500)
    }

    toggleTemplateFilter(event) {
        if (document.getElementById("filterList").value === "2") {
            document.getElementById("filterTemplate").disabled = false;
            document.getElementById("filterTemplateUnpublished").disabled = false;
        }
        else if (document.getElementById("filterList").value === "3") {
            document.getElementById("filterTemplate").disabled = false;
            document.getElementById("filterTemplateUnpublished").disabled = true;
        }
        else {
            document.getElementById("filterTemplate").disabled = true;
            document.getElementById("filterTemplate").value = "0";
            document.getElementById("filterTemplateUnpublished").disabled = true;
            document.getElementById("filterTemplateUnpublished").value = "0";
        }
    }

    loadMore() {

        let currPage = this.state.page + 1;


        var listFilter = document.getElementById("filterList").value;
        var listTemplate = document.getElementById("filterTemplate").value;
        var listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;
        var listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
        var listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
        var textDescription = document.getElementById("unproc_description").value.toUpperCase();
        var textPart = document.getElementById("unproc_part").value.toUpperCase();

        var filteredParams = {
            "listTypeFilter": listFilter,
            "publishedTemplateFilter": listTemplate,
            "unpublishedTemplateFilter": listTemplateUnpublished,
            "manufacturerFilter": listManufacturer,
            "productLineFilter": listProductLine,
            "partFilter": textPart,
            "descriptionFilter": textDescription
        }

        filteredParams.pageIndex = currPage;
        filteredParams.sortBy = this.state.sortBy;
        filteredParams.sortOrder = this.state.sortOrder;

        this.setState({ page: currPage });

        if (listTemplate === "0" && listTemplateUnpublished === "0") {
            fetchUnprocessedRecordsList(this.props.dispatch, filteredParams);
        }
        else if (listTemplate !== "0" && listTemplateUnpublished === "0") {
            fetchUnprocessedRecordsPublishedTemplateList(this.props.dispatch, filteredParams);
        }
        else if (listTemplate === "0" && listTemplateUnpublished !== "0") {
            fetchUnprocessedRecordsUnpublishedTemplateList(this.props.dispatch, filteredParams);
        }

    }

    isExportButtonEnabled() {
        return (this.state.listFilterValue === "1"
            || this.state.listFilterValue === "2" && this.state.publishedTemplateFilterValue !== "0"
            || this.state.listFilterValue === "2" && this.state.templateUnpublishedFilterValue !== "0"
            || this.state.listFilterValue === "3" && this.state.publishedTemplateFilterValue !== "0"
        );
    }

    toggleExportButton() {
        if (this.isExportButtonEnabled()) {
            document.getElementById("buttonExport").removeAttribute("disabled");
        } else {
            document.getElementById("buttonExport").setAttribute("disabled",  "disabled");
        }
    }

    fetchUnprocessedRecordsErrorClear() {
        this.props.dispatch(fetchUnprocessedRecordsError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    sortUnprocessedRecordsOperation(dispatch, list, id, asc) {
        sortUnprocessedRecords.bind(this)(dispatch, list, id, asc);
    }

    sortUnprocessedRecordsCall(dispatch, list, id, asc) {
        if (asc === "fa-sort") {
            //sortUnprocessedRecords.bind(this)(this.props.unprocessedRecordsList.unprocessedRecordsList, element.id, true);
            this.sortUnprocessedRecordsOperation(dispatch, list, id, true);
        }
        else if (asc === "fa fa-sort-desc") {
            //sortUnprocessedRecords.bind(this)(this.props.unprocessedRecordsList.unprocessedRecordsList, element.id, false);
            this.sortUnprocessedRecordsOperation(dispatch, list, id, false);
        }
        else {
            //sortUnprocessedRecords.bind(this)(this.props.unprocessedRecordsList.unprocessedRecordsList, element.id, true);
            this.sortUnprocessedRecordsOperation(dispatch, list, id, true);

        }
    }

    updateSearchAndToggle(event)
    {
        this.updateSearch(event);
        this.toggleExportButton();   
    }

    tooltipEnter(e) {   
        // Should be done using state
        if (e.currentTarget.className.includes('information_icon'))
        {
           // document.getElementsByClassName("tooltiptext3")[0].style.visibility = "visible";
        }
    }
    tooltipLeave(e) {
        // Should be done using state
        if (e.currentTarget.className.includes('information_icon')) {
        //    document.getElementsByClassName("tooltiptext3")[0].style.visibility = "hidden";
        }
    }

    close_modal(event)
    {
        document.getElementById('myModal').style.display = "none";

        if (this.props.unprocessed_records.jobInfo) {
            this.setState({ jobInfo: true })
        }
    }

    close_modal_success(event) {
        document.getElementById("success_modal_text").innerHTML = "";
        document.getElementById('successModal').style.display = "none";
    }

    close_modal_error(event) {
        document.getElementById('errorModal').style.display = "none";
       // document.getElementById("myBtn").click();
    }

    jobInfoClearImport() {
        this.setState({ jobInfo: false })
    }

    jobInfoClearExport() {
        clear_export(this.props.dispatch)
    }

    import_popup(event) {

        var modal = document.getElementById('myModal');

        var btn = document.getElementById("myBtn");

        var span = document.getElementsByClassName("close")[0];

        modal.style.display = "block";


        window.onclick = function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }
    }

    import_success_popup(event)
    {
        var modal = document.getElementById('successModal');

        var btn = document.getElementById("myBtn");

        var span = document.getElementsByClassName("close")[0];

        modal.style.display = "block";


        window.onclick = function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }
    }

    import_export_error_popup(event) {
        var modal = document.getElementById('errorModal');

        modal.style.display = "block";

        window.onclick = function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }
    }

    updateSearch(event) {
        this.setState({ page: 1 });

        if (event.target.id === "filterList") {
            this.toggleTemplateFilter(event);
        }

        var listFilter = document.getElementById("filterList").value;
        var listTemplate = document.getElementById("filterTemplate").value;
        var listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;
        var listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
        var listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
        var textDescription = document.getElementById("unproc_description").value.toUpperCase();
        var textPart = document.getElementById("unproc_part").value.toUpperCase();
        var filterChosen = "";

        this.setState({ page: 1 });

        if (event.target.id === document.getElementById("filterTemplate").id) {
            filterChosen = "PublishedTemplate";
        }
        else if (event.target.id === document.getElementById("filterTemplateUnpublished").id) {
            filterChosen = "UnpublishedTemplate";
        }
        else if (event.target.id === document.getElementById("filterManufacturer").id) {
            filterChosen = "Manufacturer";
        }
        else if (event.target.id === document.getElementById("filterProductLine").id) {
            filterChosen = "ProductLines";
        }
        else {
            filterChosen = "None";
        }

        if (event.target.id === document.getElementById("filterTemplateUnpublished").id) {
            document.getElementById("filterTemplate").value = 0;
            document.getElementById("filterTemplate").disabled = true;
            var filteredParams1 = {
                "listTypeFilter": listFilter,
                "unpublishedTemplateFilter": listTemplateUnpublished,
                "publishedTemplateFilter": listTemplate,
                "manufacturerFilter": "0",
                "productLineFilter": "0",
                "partFilter": "",
                "descriptionFilter": "",
                "filterChosen": filterChosen,
                "sortBy": this.state.sortBy,
                "sortOrder": this.state.sortOrder

            }



            if (event.target.value === "0") {

                fetchUnprocessedRecordsList(this.props.dispatch, filteredParams1);

                var hasActive = false;

                $('th').each(function (i, l) {
                    var element = l;
                    let sort = element.children[0].className.split(' ')[1];
                    if (sort !== "fa-sort") {
                        hasActive = true;
                    }
                });
                if (hasActive === true) {

                    var element1 = document.getElementById("brprid");
                    let sort1 = element1.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element1.id, sort1);

                    var element2 = document.getElementById("brmfg");
                    let sort2 = element2.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element2.id, sort2);

                    var element3 = document.getElementById("brlin");
                    let sort3 = element3.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element3.id, sort3);

                    var element4 = document.getElementById("brpart");
                    let sort4 = element4.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element4.id, sort4);

                    var element5 = document.getElementById("brdes1");
                    let sort5 = element5.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element5.id, sort5);

                    var element6 = document.getElementById("brdes2");
                    let sort6 = element6.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element6.id, sort6);

                    var element7 = document.getElementById("brdes3");
                    let sort7 = element7.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element7.id, sort7);

                    var element8 = document.getElementById("templateid");
                    let sort8 = element8.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element8.id, sort8);

                    var element9 = document.getElementById("templatename");
                    let sort9 = element9.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element9.id, sort9);

                    var element10 = document.getElementById("supplemental_missing");
                    let sort10 = element10.children[0].className.split(' ')[1]

                    this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element10.id, sort10);

                }

                //  alert(event.target.value);
                document.getElementById("filterTemplate").disabled = false;
                //   fetchUnprocessedRecordsList(this.props.dispatch, filteredParams1);
            }
            else {
                fetchUnprocessedRecordsUnpublishedTemplateList(this.props.dispatch, filteredParams1);
            }
            this.setState({ listFilterValue: document.getElementById("filterList").value });
            this.setState({ publishedTemplateFilterValue: document.getElementById("filterTemplate").value });
            this.setState({ templateUnpublishedFilterValue: document.getElementById("filterTemplateUnpublished").value });
            this.setState({ manufacturerFilterValue: listManufacturer });
            this.setState({ productLineFilterValue: listProductLine });

            // process_filter(this.props.dispatch, filteredParams1);
            // document.getElementById("unprocessedRecords").style.width = "983px";
        }
        else if (event.target.id === document.getElementById("filterTemplate").id) {
            document.getElementById("filterTemplateUnpublished").value = 0;
            document.getElementById("filterTemplateUnpublished").disabled = true;
            var filteredParams2 = {
                "listTypeFilter": listFilter,
                "publishedTemplateFilter": listTemplate,
                "unpublishedTemplateFilter": listTemplateUnpublished,
                "manufacturerFilter": "0",
                "productLineFilter": "0",
                "partFilter": "",
                "descriptionFilter": "",
                "filterChosen": filterChosen,
                "sortBy": this.state.sortBy,
                "sortOrder": this.state.sortOrder
            }

            if (event.target.value === "0") {
                document.getElementById("filterTemplateUnpublished").disabled = false;

                fetchUnprocessedRecordsList(this.props.dispatch, filteredParams2);
            }
            else {
                //fetchUnprocessedRecordsPublishedTemplateList(this.props.dispatch, filteredParams2);
                fetchUnprocessedRecordsList(this.props.dispatch, filteredParams2);
            }
            this.setState({ listFilterValue: document.getElementById("filterList").value });
            this.setState({ publishedTemplateFilterValue: document.getElementById("filterTemplate").value });
            this.setState({ templateUnpublishedFilterValue: document.getElementById("filterTemplateUnpublished").value });
            this.setState({ manufacturerFilterValue: listManufacturer });
            this.setState({ productLineFilterValue: listProductLine });

            hasActive = false;

            $('th').each(function (i, l) {
                var element = l;
                let sort = element.children[0].className.split(' ')[1];
                if (sort !== "fa-sort") {
                    hasActive = true;
                }
            });


            if (hasActive === true) {

                element1 = document.getElementById("brprid");
                let sort1 = element1.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element1.id, sort1);

                element2 = document.getElementById("brmfg");
                let sort2 = element2.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element2.id, sort2);

                element3 = document.getElementById("brlin");
                let sort3 = element3.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element3.id, sort3);

                element4 = document.getElementById("brpart");
                let sort4 = element4.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element4.id, sort4);

                 element5 = document.getElementById("brdes1");
                let sort5 = element5.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element5.id, sort5);

                 element6 = document.getElementById("brdes2");
                let sort6 = element6.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element6.id, sort6);

                 element7 = document.getElementById("brdes3");
                let sort7 = element7.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element7.id, sort7);

                 element8 = document.getElementById("templateid");
                let sort8 = element8.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element8.id, sort8);

                 element9 = document.getElementById("templatename");
                let sort9 = element9.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element9.id, sort9);

                 element10 = document.getElementById("supplemental_missing");
                let sort10 = element10.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element10.id, sort10);
            }




            // document.getElementById("unprocessedRecords").style.width = "983px";
        }

        else {
           

            if (event.target.id === "filterList" && event.target.value === "2") {
                document.getElementById("filterManufacturer").disabled = true;
                document.getElementById("filterProductLine").disabled = true;
                document.getElementById("unproc_description").disabled = true;
                document.getElementById("unproc_part").disabled = true;
            }
            else {
                document.getElementById("filterManufacturer").disabled = false;
                document.getElementById("filterProductLine").disabled = false;
                document.getElementById("unproc_description").disabled = false;
                document.getElementById("unproc_part").disabled = false;
            }

            listFilter = document.getElementById("filterList").value;
            listTemplate = document.getElementById("filterTemplate").value;
            listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;
            listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
            listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
            textDescription = document.getElementById("unproc_description").value.toUpperCase();
            textPart = document.getElementById("unproc_part").value.toUpperCase();


            if (event.target.id === "filterList" && event.target.value === "2") {

                var filteredParams = {
                    "listTypeFilter": listFilter,
                    "publishedTemplateFilter": listTemplate,
                    "unpublishedTemplateFilter": listTemplateUnpublished,
                    "manufacturerFilter": "0",
                    "productLineFilter": "0",
                    "partFilter": "",
                    "descriptionFilter": "",
                    "filterChosen": filterChosen,
                    "sortBy": this.state.sortBy,
                    "sortOrder": this.state.sortOrder
                }
            }
            else {
                filteredParams = {
                    "listTypeFilter": listFilter,
                    "publishedTemplateFilter": listTemplate,
                    "unpublishedTemplateFilter": listTemplateUnpublished,
                    "manufacturerFilter": listManufacturer,
                    "productLineFilter": listProductLine,
                    "partFilter": textPart,
                    "descriptionFilter": textDescription,
                    "filterChosen": filterChosen,
                    "sortBy": this.state.sortBy,
                    "sortOrder": this.state.sortOrder
                }
            }

            fetchUnprocessedRecordsList(this.props.dispatch, filteredParams);

            this.setState({ listFilterValue: listFilter });
            this.setState({ publishedTemplateFilterValue: listTemplate });
            this.setState({ templateUnpublishedFilterValue: listTemplateUnpublished });
            this.setState({ manufacturerFilterValue: listManufacturer });
            this.setState({ productLineFilterValue: listProductLine });
            hasActive = false;

            $('th').each(function (i, l) {
                var element = l;
                let sort = element.children[0].className.split(' ')[1];
                if (sort !== "fa-sort") {
                    hasActive = true;
                }
            });

            if (hasActive === true) {
                 element1 = document.getElementById("brprid");
                let sort1 = element1.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element1.id, sort1);

                 element2 = document.getElementById("brmfg");
                let sort2 = element2.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element2.id, sort2);

                 element3 = document.getElementById("brlin");
                let sort3 = element3.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element3.id, sort3);

                 element4 = document.getElementById("brpart");
                let sort4 = element4.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element4.id, sort4);

                 element5 = document.getElementById("brdes1");
                let sort5 = element5.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element5.id, sort5);

                 element6 = document.getElementById("brdes2");
                let sort6 = element6.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element6.id, sort6);

                 element7 = document.getElementById("brdes3");
                let sort7 = element7.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element7.id, sort7);

                 element8 = document.getElementById("templateid");
                let sort8 = element8.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element8.id, sort8);

                 element9 = document.getElementById("templatename");
                let sort9 = element9.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element9.id, sort9);

                 element10 = document.getElementById("supplemental_missing");
                let sort10 = element10.children[0].className.split(' ')[1]

                this.sortUnprocessedRecordsCall(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, element10.id, sort10);

            }
        }

    }

    showAllRecords(event) {
        show_all_records(this.props.dispatch, true);
    }

    sortColumn(e) {
        this.setState({ page: 1 });
        let sortElement = e.target;
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
            sortUnprocessedRecords.bind(this)(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, sortElement.id, true)
        }
        else if (sort === "fa-sort-asc") {
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
            sortUnprocessedRecords.bind(this)(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, sortElement.id, false)
        }
        else {
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
            sortUnprocessedRecords.bind(this)(this.props.dispatch, this.props.unprocessedRecordsList.unprocessedRecordsList, sortElement.id, true)
        }

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"

        $('th').each(function () {
            $(this).attr('sort', sortElement.id)
        })

        var listFilter = document.getElementById("filterList").value;
        var listTemplate = document.getElementById("filterTemplate").value;
        var listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;
        var listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
        var listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
        var textDescription = document.getElementById("unproc_description").value.toUpperCase();
        var textPart = document.getElementById("unproc_part").value.toUpperCase();
        var sortOrder=""

        if (sort === "fa-sort") {
            sortOrder = "Ascending";
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending";
        }
        else {
            sortOrder = "Ascending";
        }


        if (sortElement.id === "templateid") {
            sortElement.id = "ProductTemplateId";
        }
        else if (sortElement.id === "templatename") {
            sortElement.id = "UnprocessedRecordName";
        }
        else if (sortElement.id === "supplemental_missing") {
            sortElement.id = "SupplementalDataMissing";
        }


        var filteredParams = {
            "listTypeFilter": listFilter,
            "unpublishedTemplateFilter": listTemplate,
            "publishedTemplateFilter": listTemplateUnpublished,
            "manufacturerFilter": listManufacturer,
            "productLineFilter": listProductLine,
            "partFilter": textPart,
            "descriptionFilter": textDescription,
            "sortBy": sortElement.id,
            "sortOrder": sortOrder

        }
        this.setState({ sortOrder: sortOrder });
        this.setState({ sortBy: sortElement.id });

        fetchUnprocessedRecordsList(this.props.dispatch, filteredParams);
    }

    clearForm()
    {
        if (this.props.unprocessedRecordsList.fetching) return

        document.getElementById("filterList").value = 0;
        document.getElementById("filterTemplate").value = 0;
        document.getElementById("filterTemplateUnpublished").value = 0;
        document.getElementById("filterManufacturer").value = 0;
        document.getElementById("filterProductLine").value = 0;
        document.getElementById("unproc_part").value = "";
        document.getElementById("unproc_description").value = "";

        this.setState({ listFilterValue: '0' });
        this.setState({ publishedTemplateFilterValue: '0' });
        this.setState({ templateUnpublishedFilterValue: '0' });
        this.setState({ manufacturerFilterValue: '0' });
        this.setState({ productLineFilterValue: '0' });

        var listFilter = document.getElementById("filterList").value;
        var listTemplate = document.getElementById("filterTemplate").value;
        var listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;
        var listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
        var listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
        var textDescription = document.getElementById("unproc_description").value.toUpperCase();
        var textPart = document.getElementById("unproc_part").value.toUpperCase();

        var filteredParams = {
            "listTypeFilter": listFilter,
            "unpublishedTemplateFilter": listTemplate,
            "publishedTemplateFilter": listTemplateUnpublished,
            "manufacturerFilter": listManufacturer,
            "productLineFilter": listProductLine,
            "partFilter": textPart,
            "descriptionFilter": textDescription
        }
        fetchUnprocessedRecordsList(this.props.dispatch, filteredParams);
        show_all_records(this.props.dispatch, false);
        document.getElementById("filterTemplateUnpublished").value = 0;
        document.getElementById("filterTemplateUnpublished").disabled = true;
        document.getElementById("filterTemplate").value = 0;
        document.getElementById("filterTemplate").disabled = true;
        this.toggleExportButton();
        //process_filter(this.props.dispatch, filteredParams);
    }

    turn_off_progress_bar()
    {
        document.getElementById("progress_bar").display = "none";

    }

    prepareFileChosen(event) {
        this.handleFileChosen(event);
    }

    handleFileChosen(event) {
        var mimeType = event.target.files[0]['type'];
        if (mimeType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        {
            alert("The File uploaded must be an excel spreadsheet wtih the file extension .xlsx");
            document.getElementById("fileChooseButton").value = null;
            return;
        }

        // document.getElementById("progress_bar_upload").style.display = "inline";
        document.getElementById("startImport").style.display = "inline";

        // console.log(JSON.stringify(coreArray));

        import_excel_unprocessedrecords(this.props.dispatch, this.props.unprocessed_records.user, event.target.files[0]);

        //   event.target.files = "";
    }

    import_and_end(event) {
        if (this.props.unprocessedRecordsList.fetching) return

        //this.handleFileChosen(event);
        document.getElementById("fileChooseButton").click();      
    }

    exportExcel(event) {
       // document.getElementById("progress_bar").style.display = "inline";
        var listFilter = document.getElementById("filterList").value;
        var listTemplate = document.getElementById("filterTemplate").value;
        var listTemplateUnpublished = document.getElementById("filterTemplateUnpublished").value;

        var filters = {
            "listTypeFilter": listFilter,
            "unpublishedTemplateFilter": listTemplateUnpublished,
            "publishedTemplateFilter": listTemplate,
        };

        if (listFilter == "1")
        {
            var listManufacturer = document.getElementById("filterManufacturer").value.toUpperCase();
            var listProductLine = document.getElementById("filterProductLine").value.toUpperCase();
            var textPart = document.getElementById("unproc_part").value.toUpperCase();
            var textDescription = document.getElementById("unproc_description").value.toUpperCase();

            filters["manufacturerFilter"] = listManufacturer;
            filters["productLineFilter"] = listProductLine;
            filters["partFilter"] = textPart;
            filters["descriptionFilter"] = textDescription;
        }

        export_excel_unprocessedrecords(this.props.dispatch, this.props.unprocessed_records.user, filters, this.turn_off_progress_bar());

    }

    showJobId() {
        if (this.props.unprocessed_records.jobInfo.title == 'Import')
            this.jobInfoClearImport()
        else
            this.jobInfoClearExport()

        window.location = "/prod-mgmt/jobslist/" + this.props.unprocessed_records.jobInfo.jobId
    }

    render() {
        let templateIdSet = [];
        var showAllRecords = 0;

        return (
            <div id="unprocessedRecords" className="col-xs-12">
                <CommError error={this.props.unprocessed_records.error} onClose={this.fetchUnprocessedRecordsErrorClear} />
                {
                    this.props.unprocessed_records.jobInfo && this.props.unprocessed_records.jobInfo.title == 'Import' ?
                        <BootstrapErrorModal
                            show={this.state.jobInfo}
                            title={this.props.unprocessed_records.jobInfo.title}
                            body={<div><span>Job ID: </span> <a id="JobID" onClick={this.showJobId}>{this.props.unprocessed_records.jobInfo.jobId}</a> <span>is</span> <span>{this.props.unprocessed_records.jobInfo.status}</span></div>}
                            onClose={this.jobInfoClearImport}
                        />
                    : null
                }
                {
                    this.props.unprocessed_records.jobInfo && this.props.unprocessed_records.jobInfo.title == 'Export' ?
                        <BootstrapErrorModal
                            show={true}
                            title={this.props.unprocessed_records.jobInfo.title}
                            body={<div><span>Job ID: </span> <a id="JobID" onClick={this.showJobId}>{this.props.unprocessed_records.jobInfo.jobId}</a> <span>is</span> <span>{this.props.unprocessed_records.jobInfo.status}</span></div>}
                            onClose={this.jobInfoClearExport}
                        />
                    : null
                }

                <ConfirmModal open={this.props.unprocessed_records.noData} heading={"Unprocessed Records"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapperUnprocessed">
                    <div className="unprocessedRecordsHeader">
                        <h1>Unprocessed Records</h1>
                    </div>
                </div>
                <font size="2">List of AS400 product that does not have a template assigned or are we missing supplemental data. User can export and import lists as needed.</font>
                <br />
                <font size="2">*= Required for Export</font>
                <br />
                Filter On:
                <br />
                <br />

                {
                    this.props.unprocessedRecordsList.fetching ?
                        <Spinner name='line-spin-fade-loader' />
                    :
                        null
                }

                <div className="filters">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <div className="unproc_opts form-group">
                                <label>List Type:*</label>
                                {
                                    this.props.unprocessedRecordsList.fetching ?
                                        <select id="filterList" className="web1 form-control" disabled>
                                            <option value="0">Select</option>
                                            <option value="1">Missing Template</option>
                                            <option value="2">Missing Supplemental</option>
                                            <option value="3">Missing AS400Attribute</option>
                                        </select>
                                    :
                                        <select id="filterList" className="web1 form-control" onChange={this.updateSearchAndToggle.bind(this)}>
                                            <option value="0">Select</option>
                                            <option value="1">Missing Template</option>
                                            <option value="2">Missing Supplemental</option>
                                            <option value="3">Missing AS400Attribute</option>
                                        </select>
                                }
                            </div>
                            <div className="unproc_opts form-group">
                                <label>Published Template*:</label>
                                <select id="filterTemplate" value={this.state.publishedTemplateFilterValue} disabled="disabled" className="web1 form-control" onChange={this.updateSearchAndToggle.bind(this)}>
                                    <option value="0">Select</option>
                                    {
                                        this.props.unprocessedRecordsList.unprocessedRecordsList ?
                                            this.props.unprocessedRecordsList.publishedTemplateNames.sort(function(a, b) 
                                                {
                                                a = a.substr(a.indexOf('-') + 1).toLowerCase();
                                                b = b.substr(b.indexOf('-') + 1).toLowerCase();
                                                if (a > b) {
                                                    return 1;
                                                }
                                                else if (a < b) {
                                                    return -1;
                                                }
                                                else {
                                                    return 0;
                                                }
                                                })
                                             .map((templateName, index) => {
                                            var tempid = templateName.substr(0, templateName.indexOf('-')); // "72"
                                            var tempname = templateName.substr(templateName.indexOf('-') + 1); // "tocirah sneab"
                                            return <option value={tempid} key={index}>
                                                {tempname}
                                            </option>;
                                        }) : null
                                    }
                                </select>
                            </div>
                            <div className="unproc_opts form-group">
                                <label>Unpublished Template*:</label>
                                <select id="filterTemplateUnpublished" value={this.state.templateUnpublishedFilterValue} disabled="disabled" className="web1 form-control" onChange={this.updateSearchAndToggle.bind(this)}>
                                    <option value="0">Select</option>
                                    {
                                        this.props.unprocessedRecordsList.unprocessedRecordsList ? this.props.unprocessedRecordsList.unpublishedTemplateNames.sort(function (a,b)
                                        {
                                            a = a.substr(a.indexOf('-') + 1).toLowerCase();
                                            b = b.substr(b.indexOf('-') + 1).toLowerCase();
                                            if (a > b) {
                                                return 1;
                                            }
                                            else if (a < b) {
                                                return -1;
                                            }
                                            else {
                                                return 0;
                                            }
                                        })
                                            .map((templateName, index) => {
                                            var tempid = templateName.substr(0, templateName.indexOf('-')); // "72"
                                            var tempname = templateName.substr(templateName.indexOf('-') + 1); // "tocirah sneab"
                                            return <option value={tempid} key={index}>
                                                {tempname}
                                            </option>;
                                            //   }
                                        }) : null
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="unproc_opts form-group">
                                <label>Manufacturer Code(iSeries):</label>
                                {
                                    this.props.unprocessedRecordsList.fetching ?
                                        <select id="filterManufacturer" value={this.state.manufacturerFilterValue} className="web1 form-control" disabled>
                                            <option value="0">Select</option>
                                            {
                                                this.props.unprocessedRecordsList.manufacturerCodes ? this.props.unprocessedRecordsList.manufacturerCodes.sort((a, b) => a - b).map((manuCodes, index) => {
                                                    return <option value={manuCodes} key={index}>
                                                        {manuCodes}
                                                    </option>;
                                                }) : null
                                            }
                                        </select>
                                    :
                                        <select id="filterManufacturer" value={this.state.manufacturerFilterValue} className="web1 form-control" onChange={this.updateSearch.bind(this)}>
                                            <option value="0">Select</option>
                                            {
                                                this.props.unprocessedRecordsList.manufacturerCodes ? this.props.unprocessedRecordsList.manufacturerCodes.sort((a, b) => a - b).map((manuCodes, index) => {
                                                    return <option value={manuCodes} key={index}>
                                                        {manuCodes}
                                                    </option>;
                                                }) : null
                                            }
                                        </select>
                                }
                            </div>
                            <div className="unproc_opts form-group">
                                <label>Line Code(iSeries):</label>
                                {
                                    this.props.unprocessedRecordsList.fetching ?
                                        <select id="filterProductLine" value={this.state.productLineFilterValue} className="web1 form-control" disabled>
                                            <option value="0">Select</option>
                                            {
                                                this.props.unprocessedRecordsList.productLines ? this.props.unprocessedRecordsList.productLines.sort((a, b) => a - b).map((prodLines, index) => {
                                                    return <option value={prodLines} key={index}>
                                                        {prodLines}
                                                    </option>;
                                                }) : null
                                            }
                                        </select>
                                    :
                                        <select id="filterProductLine" value={this.state.productLineFilterValue} className="web1 form-control" onChange={this.updateSearch.bind(this)}>
                                            <option value="0">Select</option>
                                            {
                                                this.props.unprocessedRecordsList.productLines ? this.props.unprocessedRecordsList.productLines.sort((a, b) => a - b).map((prodLines, index) => {
                                                    return <option value={prodLines} key={index}>
                                                        {prodLines}
                                                    </option>;
                                                }) : null
                                            }
                                        </select>
                                }
                            </div>
                            <div className="unproc_opts form-group">
                                <label>Part#:</label>
                                {
                                    this.props.unprocessedRecordsList.fetching ?
                                        <input id="unproc_part" className="unproc form-control" disabled />
                                    :
                                        <input id="unproc_part" className="unproc form-control" onBlur={this.updateSearch.bind(this)} />
                                }
                            </div>
                            <div className="unproc_opts form-group">
                                <label>Description:</label>
                                {
                                    this.props.unprocessedRecordsList.fetching ?
                                        <input id="unproc_description" className="unproc form-control" disabled />
                                    :
                                        <input id="unproc_description" className="unproc form-control" onBlur={this.updateSearch.bind(this)} />
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="unproc_opts form-group">
                                    <button className="button-clear btn btn-default" onClick={this.clearForm}>Clear</button>&nbsp;
                                    {this.isExportButtonEnabled() ?
                                        <button id="buttonExport" className="button-export btn" onClick={this.exportExcel.bind(this)} >Export</button> 
                                        :
                                        <button id="buttonExport" className="button-export btn" onClick={this.exportExcel.bind(this)} disabled >Export</button>
                                    }&nbsp;
                                    <button className="button-import btn btn-primary" onClick={this.import_and_end}>Import</button>&nbsp;
                                    <span className="circle tooltips">
                                    <i className="fa fa-info-circle information_icon"></i>&nbsp;
                                    <span className="tooltips_text">
                                        <center>Export Specifications:</center>
                                        <span id="align_tooltip">&nbsp;2 Types of Exports:  Missing Templates and Missing Supplemental Data</span><br />
                                        <span id="align_tooltip">&nbsp;For Missing Supplemental Data a published or unpublished template must be selected for the file to be downloaded</span>
                                        <br /><br />
                                        <center>Import Specifications:</center>
                                        <span id="align_tooltip">&nbsp;Fields Required:</span><br />
                                        <span id="align_tooltip">&nbsp;Product Master ID</span><br />
                                        <span id="align_tooltip">&nbsp;ManufacturerProduct Line Code</span><br />
                                        <span id="align_tooltip">&nbsp;Manufacturer Part Number</span><br />
                                        <span id="align_tooltip">&nbsp;Description (1, 2 and 3)</span><br />
                                        <span id="align_tooltip">&nbsp;Template Name</span><br />
                                        <span id="align_tooltip">&nbsp;Supplemental Data Fields</span><br />
                                        <span id="align_tooltip">&nbsp;Import Files must be excel Format</span><br /><br />
                                        <span id="align_tooltip">&nbsp;Supplemental Data Field Headers must be a valid brick for the template being loaded.
                                            If any headers are missing a format error will be returned and file will not be loaded.
                                            Any rows with invalid data will NOT be loaded (error report will be provided after import process completed)</span>
                                        </span>
                                    </span>
                                    <input id="fileChooseButton" type="file" onChange={this.prepareFileChosen.bind(this)} accept=".xlsx" />

                                    <div className="pagination">
                                        {
                                            this.props.unprocessedRecordsList.pages <= this.state.page * 100 ?
                                                <p>{this.props.unprocessedRecordsList.pages} Results (Viewing 1-{this.props.unprocessedRecordsList.pages} of {this.props.unprocessedRecordsList.pages})</p>
                                            :
                                                <p>{this.props.unprocessedRecordsList.pages} Results (Viewing 1-{this.state.page * 100 > this.props.unprocessedRecordsList.pages ? this.props.unprocessedRecordsList.pages : this.state.page * 100} of {this.props.unprocessedRecordsList.pages})</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span id="startExport">
                {
                    this.props.unprocessedRecordsList.complete_export === false ?
                            <LoadingSpinner />
                    :
                        null
                }
                </span>
                <span id="startImport">
                    {
                        this.props.unprocessedRecordsList.complete_import === false ?
                            <ImportSpinner />
                        :
                            null
                    }
                </span>
                <span id="progress_bar"><strong> Export Progress: {this.props.unprocessedRecordsList.percent_complete}%</strong>
                    <ProgressBar percentage={this.props.unprocessedRecordsList.percent_complete} />
                </span>
                <span id="progress_bar_upload"><strong> Import Progress: {this.props.unprocessedRecordsList.percent_complete}%</strong>
                    <ProgressBar percentage={this.props.unprocessedRecordsList.percent_complete} />
                </span>
                <center> <div id="myModal" class="modal">

                     <div id="modal-content" class="modal-content">
                        <div id="modal-header" class="modal-header">
                            <span class="close" onClick={this.close_modal.bind(this)}>&times;</span>
                            <h2>Error List</h2>
                        </div>
                        <div id="modal-body" class="modal-body">
                            <p>Import Completed With Errors Records Found</p><br/>
                            <p id="modal_text"></p>
                        </div>
                    </div>
                </div>
                </center>

                <div id="successModal" class="modal">
                    <div id="success-modal-content" class="modal-content">
                        <div id="modal-header" class="modal-header">
                            <span class="close" onClick={this.close_modal_success.bind(this)}>&times;</span>
                            <h2>Unprocessed Records</h2>
                        </div>
                        <div id="modal-body" class="modal-body">
                            <p id="success_modal_text"></p>
                            <center><button type="button" class=" btn" onClick={this.close_modal_success.bind(this)}>Ok</button></center>
                        </div>
                    </div>
                </div>

                <center> <div id="errorModal" class="modal">

                    <div id="error-modal-content" class="modal-content">
                        <div id="modal-header" class="modal-header">
                            <span class="close" onClick={this.close_modal_error.bind(this)}>&times;</span>
                            <h2>Error</h2>
                        </div>
                        <div id="modal-body" class="modal-body">
                            <p id="error_modal_text"></p>
                        </div>
                    </div>
                </div>
                </center>
                <button id="myBtn" onClick={this.import_popup.bind(this)}>Open Modal</button>
                <button id="myBtnSuccess" onClick={this.import_success_popup.bind(this)}>Open Modal</button>
                <button id="myBtnError" onClick={this.import_export_error_popup.bind(this)}>Open Modal</button>
                <div className="tableWrapper">
                    <table id="unprocessed_records_table" className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th id="brprid" onClick={this.sortColumn.bind(this)}>BRPRID<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brmfg" onClick={this.sortColumn.bind(this)}>BRMFG<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brlin" onClick={this.sortColumn.bind(this)}>BRLIN<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brpart" onClick={this.sortColumn.bind(this)}>BRPART<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brdes1" onClick={this.sortColumn.bind(this)}>BRDES1<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brdes2" onClick={this.sortColumn.bind(this)}>BRDES2<i className="fa fa-sort fa-xs"></i></th>
                                <th id="brdes3" onClick={this.sortColumn.bind(this)}>BRDES3<i className="fa fa-sort fa-xs"></i></th>
                                <th id="templateid" onClick={this.sortColumn.bind(this)}>TEMPLATEID<i className="fa fa-sort fa-xs"></i></th>
                                <th id="templatename" onClick={this.sortColumn.bind(this)}>TEMPLATE NAME<i className="fa fa-sort fa-xs"></i></th>
                                <th id="supplemental_missing" onClick={this.sortColumn.bind(this)}>SUPP MISSING<i className="fa fa-sort fa-xs"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                this.props.unprocessedRecordsList.unprocessedRecordsList ? this.props.unprocessedRecordsList.unprocessedRecordsList.map((unprocessedRecord, index) => {
                                    var listTypeTemplateVerified = true;
                                    var listTypeSupplementalVerified = true;
                                    var templateVerified = true;
                                    var manufacturerVerified = true;
                                    var productLineVerified = true;
                                    var descriptionVerified = true;
                                    var partVerified = true;

                                    if (this.props.unprocessedRecordsList.filter.listTypeFilter === undefined || (this.props.unprocessedRecordsList.filter.listTypeFilter === "2" ||
                                        (this.props.unprocessedRecordsList.filter.listTypeFilter === "0") || (this.props.unprocessedRecordsList.filter.listTypeFilter === "1" &&
                                            unprocessedRecord.productTemplateId.toString() === "0" && unprocessedRecord.supplementalDataMissing === false))) {
                                        listTypeTemplateVerified = true;
                                    }
                                    else {
                                        listTypeTemplateVerified = false;
                                    }

                                    if (this.props.unprocessedRecordsList.filter.listTypeFilter === undefined || this.props.unprocessedRecordsList.filter.listTypeFilter === "1" || (this.props.unprocessedRecordsList.filter.listTypeFilter === "0" || (this.props.unprocessedRecordsList.filter.listTypeFilter === "2" &&
                                        unprocessedRecord.supplementalDataMissing === true))) {
                                        listTypeSupplementalVerified = true;
                                    }
                                    else {
                                        listTypeSupplementalVerified = false;
                                    }

                                    if (this.props.unprocessedRecordsList.filter.publishedTemplateFilter === undefined || (this.props.unprocessedRecordsList.filter.publishedTemplateFilter === "0" ||
                                        this.props.unprocessedRecordsList.filter.publishedTemplateFilter === unprocessedRecord.productTemplateId.toString())) {
                                        templateVerified = true;
                                    }
                                    else {
                                        templateVerified = false;
                                    }


                                    if (this.props.unprocessedRecordsList.filter.unpublishedTemplateFilter === undefined || (this.props.unprocessedRecordsList.filter.unpublishedTemplateFilter === "0" ||
                                        this.props.unprocessedRecordsList.filter.unpublishedTemplateFilter === unprocessedRecord.productTemplateId.toString())) {
                                        templateVerified = true;
                                    }
                                    else {
                                        templateVerified = false;
                                    }

                                    if (this.props.unprocessedRecordsList.filter.manufacturerFilter === undefined || (this.props.unprocessedRecordsList.filter.manufacturerFilter === "0" ||
                                        this.props.unprocessedRecordsList.filter.manufacturerFilter.toUpperCase() === unprocessedRecord.brmfg.toUpperCase())) {
                                        manufacturerVerified = true;
                                    }
                                    else {
                                        manufacturerVerified = false;
                                    }

                                    if (this.props.unprocessedRecordsList.filter.productLineFilter === undefined || (this.props.unprocessedRecordsList.filter.productLineFilter === "0" ||
                                        this.props.unprocessedRecordsList.filter.productLineFilter.toUpperCase() === unprocessedRecord.brlin.toUpperCase())) {
                                        productLineVerified = true;
                                    }
                                    else {
                                        productLineVerified = false;
                                    }

                                    if ((this.props.unprocessedRecordsList.filter.descriptionFilter === undefined || (this.props.unprocessedRecordsList.filter.descriptionFilter === "" ||
                                        ((unprocessedRecord.brdeS1.toUpperCase().includes(this.props.unprocessedRecordsList.filter.descriptionFilter.toUpperCase()) ||
                                            unprocessedRecord.brdeS2.toUpperCase().includes(this.props.unprocessedRecordsList.filter.descriptionFilter.toUpperCase()) ||
                                            unprocessedRecord.brdeS3.toUpperCase().includes(this.props.unprocessedRecordsList.filter.descriptionFilter.toUpperCase())))))) {
                                        descriptionVerified = true;
                                    }
                                    else {
                                        descriptionVerified = false;
                                    }

                                    if ((this.props.unprocessedRecordsList.filter.partFilter === undefined || (this.props.unprocessedRecordsList.filter.partFilter === "" ||
                                        ((unprocessedRecord.brpart.toUpperCase().includes(this.props.unprocessedRecordsList.filter.partFilter.toUpperCase())))))) {
                                        partVerified = true;
                                    }
                                    else {
                                        partVerified = false;
                                    }
                                    if (listTypeTemplateVerified && listTypeSupplementalVerified && templateVerified && manufacturerVerified && productLineVerified && descriptionVerified && partVerified) {
                                            return <tr className="body" key={index}>
                                                <td>{unprocessedRecord.brprid}</td>
                                                <td>{unprocessedRecord.brmfg}</td>
                                                <td>{unprocessedRecord.brlin}</td>
                                                <td>{unprocessedRecord.brpart}</td>
                                                <td>{unprocessedRecord.brdeS1}</td>
                                                <td>{unprocessedRecord.brdeS2}</td>
                                                <td>{unprocessedRecord.brdeS3}</td>
                                                <td>{unprocessedRecord.productTemplateId}</td>
                                                <td>{unprocessedRecord.productTemplateName}</td>
                                                <td>{unprocessedRecord.supplementalDataMissing.toString()}</td>
                                            </tr>;
                                    }
                                }) : null
                            }
                        </tbody>
                    </table>
                    {
                        this.props.unprocessedRecordsList.pages > this.state.page * 100 ?
                            <button className="btn btn-block" onClick={this.loadMore.bind(this)}>Load More</button>
                        :
                            null
                    }
                </div>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    unprocessed_records: state.unprocessed_records
});

export default connect(mapStateToProps)(UnprocessedRecords)